<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Bimbel</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Bimbel</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<div class="card-body pt-0">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#pat_medical_records" data-toggle="tab"><span class="med-records">Manajemen Bimbel</span></a>
											</li>
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
											 
										<!-- Course Records Tab -->
										<div id="pat_medical_records" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">
													
													<div class="table-responsive">
														<table id="tbl" class="table table-hover table-center mb-0">
															<thead>
																<tr>
																	<th>ID</th>
																	<th>Nama Paket</th>
																	<th>Tipe</th>
																	<th>Harga Awal</th>
																	<th>Diskon</th>
																	<th>Harga Aktif</th>
																	<!-- <th>Masa Berlaku</th> -->
																	<th>Jumlah Jadwal</th>
																	<th>Status</th>
																	<th>Aksi</th>
																</tr>     
															</thead>
															<tbody>
																<tr v-for="(ref, index) in lstpaket" :key="ref.id_paket">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.tipe_paket == '2'">BIMBEL</span>
																		<span v-else>MANDIRI</span>
																	</td>
                                                                    <td class="text-right">{{ ref.harga_awal }}</td>
                                                                    <td class="text-center">{{ ref.diskon }}%</td>
                                                                    <td class="text-right">{{ ref.harga_aktif }}</td>
                                                                    <!-- <td class="text-center">{{ ref.masa_berlaku }} bulan</td> -->
                                                                    <td class="text-center">{{ ref.jml_jadwal }} Jadwal</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.fg_publish == '2'">PUBLISH</span>
																		<span v-else>DRAFT</span>
																	</td>																	
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-info-light" depressed small @click="getJadwal(ref)">
                                                                            <i class="fas fa-edit"></i> Jadwal
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getLdt(ref)">
                                                                            <i class="fas fa-edit"></i> LearnDoTeach
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getKehadiran(ref)">
                                                                            <i class="fas fa-edit"></i> Kehadiran
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getTugas(ref)">
                                                                            <i class="fas fa-edit"></i> Tugas
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
																
															</tbody>  	
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Course Records Tab -->
										
										
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
		
		<div id="jadwalMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document" style="width:90% !important">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Manajemen Jadwal | Paket {{paket.nama_paket}}</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<form id="frm">                            
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Judul Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.judul_pertemuan">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Jadwal Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="datetime-local" v-model="paketjadwal.jadwal_pertemuan">
                                    </div>
                                </div>
								<div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>User Coach</label>
                                        <v-select :disabled="!isFormJadwal"
                                        :options="lstcoach"
                                        :reduce="lstcoach => lstcoach.id_user" 
                                        label="namauser2"
                                        v-model="paketjadwal.id_coach"
                                        />
                                        
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Nama Coach</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.nama_coach">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Pertemuan</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_pertemuan">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Rekaman</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_rekaman">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Link Materi</label>
                                        <input :disabled="!isFormJadwal" class="form-control" type="text" v-model="paketjadwal.link_materi">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
										<label>Status</label>
										<v-select  :disabled="!isFormJadwal"
										:options="lststs"
										:reduce="lststs => lststs.id" 
										label="text"
										v-model="paketjadwal.status_jadwal"
										/>
										
									</div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Pre Test</label>
                                        <v-select :disabled="!isFormJadwal"
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.pretest"
                                        />                                        
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Post Test</label>
                                        <v-select :disabled="!isFormJadwal"
                                        :options="lsttryoutjadwal"
                                        :reduce="lsttryoutjadwal => lsttryoutjadwal.id_to" 
                                        label="nama_to"
                                        v-model="paketjadwal.posttest"
                                        />
                                        
                                    </div>
                                </div>
								
                            </div>
                            <div class="submit-section text-center" v-if="isFormJadwal">
                                <button class="btn btn-info btn-sm" @click.prevent="saveJadwal">Simpan</button>
                                <button class="btn btn-danger btn-sm" @click.prevent="resetJadwal">Reset</button>
                            </div>
							<hr>

                        </form>

						<div class="table-responsive">	
							<!-- <h3>JADWAL BIMBEL</h3>																 -->
							<div class="col-auto text-right float-right ml-auto">
								<a href="#" class="btn btn-primary btn-sm" @click.prevent="addJadwal()"><i class="fa fa-plus"></i></a>
							</div>
							<table id="tblJadwal" class="table table-hover table-center mb-0">
								<thead>
									<tr>
										<!-- <th>Pertemua Ke</th> -->
										<th rowspan="2">Judul</th>
										<th rowspan="2">Jadwal</th>
										<th rowspan="2">Nama Coach</th>
										<th colspan="3">Link</th>
										<th rowspan="2">Status</th>
										<th rowspan="2">Aksi</th>
									</tr> 
									<tr>										
										<th>Pertemuan</th>
										<th>Rekaman</th>
										<th>Materi</th>
									</tr>    
								</thead>
								<tbody>
									<tr v-for="(ref, index) in lstjadwal" :key="ref">
										<!-- <td class="text-center">{{ index + 1 }}</td> -->
										<td>{{ref.judul_pertemuan}}</td>										
										<td>{{ref.jadwal_pertemuan_lbl}}</td>										
										<td>{{ref.nama_coach2}}</td>										
										<!-- <td>{{ref.link_pertemuan}}</td>										
										<td>{{ref.link_rekaman}}</td>										
										<td>{{ref.link_materi}}</td> -->
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_pertemuan == '-' , 'bg-success-light' : ref.link_pertemuan != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_pertemuan == '-' , 'fa-check' : ref.link_pertemuan != '-'}"></i></span>
										</td>
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_rekaman == '-' , 'bg-success-light' : ref.link_rekaman != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_rekaman == '-' , 'fa-check' : ref.link_rekaman != '-'}"></i></span>
										</td>	
										<td class="text-center">
											<span :class="{'badge badge-pill': true, 'bg-warning-light' : ref.link_materi == '-' , 'bg-success-light' : ref.link_materi != '-'}"><i :class="{'fas': true, 'fa-times' : ref.link_materi == '-' , 'fa-check' : ref.link_materi != '-'}"></i></span>
										</td>											
										<td class="text-center">{{ref.status_lbl}} 
											<!-- <br>
											<v-btn v-if="ref.status_jadwal=='0'"  color="btn btn-xs bg-warning-light" depressed small @click="closedJadwal(ref, 1)">
												<i class="fas fa-eye"></i>
											</v-btn>
											<v-btn v-if="ref.status_jadwal=='1'"  color="btn btn-xs bg-danger-light" depressed small @click="closedJadwal(ref, 0)">
												<i class="fas fa-eye-slash"></i>
											</v-btn> -->
										</td>										
										<!-- <td><input class="form-control" type="text" v-model="ref.judul_pertemuan"></td>										
										<td><input class="form-control" type="datetime-local"  v-model="ref.jadwal_pertemuan"></td>										
										<td><input class="form-control" type="text" v-model="ref.nama_coach"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_pertemuan"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_rekaman"></td>										
										<td><input class="form-control" type="text" v-model="ref.link_materi"></td>										
										 -->
										<td class="text-center">
											<v-btn color="btn btn-xs bg-info-light" depressed small @click="editJadwal(ref)">
												<i class="fas fa-edit"></i>
											</v-btn>
											<!-- <v-btn v-if="ref.status_jadwal=='0'"  color="btn btn-xs bg-warning-light" depressed small @click="closedJadwal(ref)">
												<i class="fas fa-check"></i>
											</v-btn> -->
											<v-btn v-if="ref.status_jadwal=='0'" color="btn btn-xs bg-danger-light" depressed small @click="deleteJadwal(ref, index)"  >
												<!--@click="getDeleteJadwal(ref)" @click="deleteJadwal(ref, index)" -->
												<i class="fas fa-times"></i>
											</v-btn>
										</td>
									</tr>
									
								</tbody>  	
							</table>																	
						</div>
					</div>
					<!-- <div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="saveJadwal">Simpan Jadwal</button>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		
        <div id="ldtMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">LearnDoTeach | Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
								<div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<!-- <label>Paket Bimbel</label> -->
											<v-select
											:options="lstjadwal"
											:reduce="lstjadwal => lstjadwal.id_paket_jadwal" 
											label="judul_pertemuan"
											v-model="id_paket_jadwal"
											placeholder="Silahkan pilih Jadwal Pertemuan"
											required
											/>
											
										</div>
									</div>
									<div class="col-md-3 ">
										<button class="btn btn-primary btn-sm float-left" @click.prevent="getLdtSiswa()"> Lihat Hasil LearnDoTeach </button>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Jumlah Soal</th>
												<th class="text-left">Action</th>
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lstldtsiswa" :key="ref.id_to">
												<td>{{ index + 1 }}</td>
												<!-- <td>{{ ref.nama_paket }}</td> -->
												<td>{{ ref.namauser }}</td>
												<td class="text-center">{{ ref.jumlah_soal }}</td>
												<td>
													<v-btn class="btn btn-sm bg-warning-light" depressed small @click="getPreview(ref)">
														<i class="fas fa-eye"></i> Preview Soal
													</v-btn>
												</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
						<br><hr><br>
                       <div class="row" v-if="lstsoal.length">
						    <br><br>
                            <div class="comp-header p-3"><h3 class="comp-title">LearnDoTeach | Peserta {{ldt.namauser}}</h3> <div class="line"></div></div>

                            <div class="col-md-12" v-for="(ref, index) in lstsoal" :key="ref.soal.id_soal">
                                <div class="card">
                                    <div class="card-header">
                                        <div class="login-header">
                                            <h3>Soal Nomor {{index+1}}
                                                <!-- <button v-if="ref.soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !ref.soal.ket_laporan, 'btn-outline-warning': ref.soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{ref.soal.ket_laporan ? "Lihat laporan soal":""}} </button> -->
                                            </h3>
                                        </div>
                                    </div>
                                    <!-- Checkout Form -->
                                    <div class="card-body">
                                
                                        <!-- Personal Information -->
                                        <div class="info-widget">

                                            <div class="row">
                                                <div class="col-md-12 col-sm-12">
                                                    <div class="titleContainer title " v-html="ref.soal.uraian_soal"></div>

                                                    <!-- quizOptions -->
                                                    <div class="optionContainer">
                                                    <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                        <div class="option" v-for="(response, idx) in ref.list_jawaban" :key="idx"
                                                       
                                                        :class="{ 'bg-info-light': (response.poin >0)}">
                                                            {{ response.jawaban }}. {{ response.uraian_jawaban }}
                                                            <button class="float-right">
                                                                <span >Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                <i class="fa" 
                                                                :class="{'fa-check':response.poin > 0}"
                                                                ></i> </button>
                                                            
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            
                                        </div>

                                        <div>
                                            <div class="login-header">
                                                    <h3>Pembahasan</h3>
                                            </div>
                                            <div class="alert alert-warning " v-html="ref.soal.pembahasan"></div>

                                            <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                        </div>
                                    </div>
                                    <!-- /Checkout Form -->
                                </div>
                                
                            </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>

		<div id="delMdlJadwal" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Jadwal</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="getJadwal(paket)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus jadwal <b>{{ paketjadwal.judul_pertemuan }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="deleteJadwal">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

		
        <div id="tugasMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tugas | Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
								<div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<!-- <label>Paket Bimbel</label> -->
											<v-select
											:options="lstjadwal"
											:reduce="lstjadwal => lstjadwal.id_paket_jadwal" 
											label="judul_pertemuan"
											v-model="id_paket_jadwal"
											placeholder="Silahkan pilih Jadwal Pertemuan"
											required
											/>
											
										</div>
									</div>
									<div class="col-md-3 ">
										<button class="btn btn-primary btn-sm float-left" @click.prevent="getTugasSiswa()"> Lihat Hasil Tugas </button>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Tgl Input Tugas</th>
												<th class="text-left">Catatan Tugas</th>
												<th class="text-left">Link Tugas</th>
												<!-- <th class="text-left">Action</th> -->
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lsttugassiswa" :key="ref.id_user_paket_jadwal">
												<td>{{ index + 1 }}</td>
												<td>{{ ref.namauser }}</td>
												<td class="text-center">{{ ref.tgl_input_tugas }}</td>
												<td>{{ ref.catatan_tugas }}</td>												
												<!-- <td>{{ ref.url_tugas }}</td> -->
												<td>
													<v-btn class="btn btn-sm bg-warning-light" depressed small @click="getLinkTugas(ref)">
														<i class="fas fa-clipboard"></i> Copy Link Tugas
													</v-btn>
												</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>


        <div id="kehadiranMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl"  role="document" style="width:90% !important">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Kehadiran | Paket {{paket.nama_paket}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
						
						<div class="card card-table">
							<div class="card-body p-3">
								<div class="row text-center">
									<div class="col-md-6">
										<div class="form-group card-label">
											<!-- <label>Paket Bimbel</label> -->
											<v-select
											:options="lstjadwal"
											:reduce="lstjadwal => lstjadwal.id_paket_jadwal" 
											label="judul_pertemuan"
											v-model="id_paket_jadwal"
											placeholder="Silahkan pilih Jadwal Pertemuan"
											required
											/>
											
										</div>
									</div>
									<div class="col-md-3 ">
										<button class="btn btn-primary btn-sm float-left" @click.prevent="getKehadiranSiswa()"> Lihat Kehadiran </button>
									</div>
								</div>
							</div>
						</div>

						<div class="card card-table mb-0">
							<div class="card-body">
								
								<div class="table-responsive">
									<table id="tblLdt" class="table table-hover table-center mb-0">
										<thead>
											<tr>
												<th class="text-left">#</th>
												<!-- <th class="text-left">Paket Bimbel</th> -->
												<th class="text-left">Nama Peserta</th>
												<th class="text-left">Status Kehadiran</th>
												<th class="text-left">Keterangan</th>
												<th class="text-left">Tgl Input Kehadiran</th>
											</tr>
										</thead>
					
										<tbody>
											
											<tr v-for="(ref, index) in lstkehadiransiswa" :key="ref.id_user_paket_jadwal">
												<td>{{ index + 1 }}</td>
												<td>{{ ref.namauser }}</td>
												<td>{{ ref.status_kehadiran_text }}</td>												
												<td>{{ ref.alasan_absen }}</td>												
												<td class="text-center">{{ ref.tgl_input_absen }}</td>
											</tr>
										</tbody>                                            
									</table>
									
								</div>
							</div>
						</div>
                    </div>
                </div>
            </div>
        </div>



	</div>
		<!-- /Main Wrapper -->
</template>


<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'
import Number  from 'vue-number-format'

export default {
    components: {
        Sidebar, Number
    },
	name: 'bimbel',
    data() {
        return {
			number: {
				decimal: '.',
				separator: ',',
				prefix: 'I ',
				// suffix: ' #',
				precision: 0,
				masked: false
			},
            lstpaket: [],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: 0,
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
				deskripsi: ''
            },			
            lststs: [
                {id: '0', text: 'OPEN'},
                {id: '1', text: 'CLOSED'}
            ],
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
			paketjadwal:{
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: '',
				id_coach: ''
            },
			refpaketjadwal:{
				id_paket_jadwal: '',
                judul_pertemuan: '',
                jadwal_pertemuan: '',
                nama_coac: '',
                link_pertemuan: '',
                link_rekaman: '',
				link_materi: '',
                pretest: '',
				posttest: '',
				status_jadwal: 0,
				id_coach: ''
            },
			isFormJadwal: false,
			lsttryoutjadwal: [],
			id_paket_jadwal:"",
			lstldtsiswa: [],
			lstsoal: [],
			ldt: [],
			nama_user:"",
			lstcoach: [],
			lsttugassiswa:[],
			lstkehadiransiswa:[]
        }
    },
    created: function () {
        this.getAll();
    },  

    methods: {		
		stripTheGarbage(e) {
			if (e.keyCode < 48 && e.keyCode !== 46 || e.keyCode > 59) {
				e.preventDefault()
			}
		},
		
		initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 8,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
					"bSort": false

                });
               }, 300)
        },

        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        // Get Product
        getAll: function () {
            axios.get('api/paket')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
					// console.log(res.data.data);
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getEditPaket: function (id_paket) {
            axios.get('api/paket/'+id_paket)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");

                    this.paket = res.data.data;

					// if(this.paket.list_benefit.length) this.lstbenefit = this.paket.list_benefit;
					// else this.lstbenefit = [];
					
					this.clearTbl("tblJadwal");
					if(this.paket.list_jadwal.length) this.lstjadwal = this.paket.list_jadwal;
					else this.lstjadwal = [];
                    this.initDt("tblJadwal");
					
					// this.clearTbl("tblToPaket");
					// if(this.paket.list_tryout.length) this.paketlsttryout = this.paket.list_tryout;
					// else this.paketlsttryout = [];
					// this.initDt("tblToPaket");
					
					// this.clearTbl("tblKategoriPaket");
					// if(this.paket.list_materi.length) this.paketlstmateri = this.paket.list_materi;
					// else this.paketlstmateri = [];
					// this.initDt("tblKategoriPaket");
					
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 		
		resetJadwal: function () {
			this.paketjadwal = [];
			this.isFormJadwal = false;
		},
		
		addJadwal: function () {
			this.paketjadwal = this.refpaketjadwal;
			this.isFormJadwal = true;
		},

		editJadwal: function (ref) {
			this.paketjadwal = ref;
			this.isFormJadwal = true;

		},

		closedJadwal: function (ref, status) {
			axios.post('api/paketjadwalstatus', {
                    id_paket: this.paket.id_paket,
					id_paket_jadwal: ref.id_paket_jadwal,
					status_jadwal: status
                })
                .then(res => {
                    // handle success
					this.clearTbl("tblJadwal");
					this.getEditPaket(this.paket.id_paket);
                    this.initDt("tblJadwal");
					this.isFormJadwal = false;
					this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
		},

		// Get Delete and Show Confirm Modal
        getDeleteJadwal: function (ref) {
			$("#jadwalMdl").modal('hide');
            this.paketjadwal = ref;			
            $("#delMdlJadwal").modal('show');
        },
 
		deleteJadwal: function(ref, index) {
			// axios.post('api/paketjadwaldel', {
			// 	id_paket: this.paket.id_paket,
			// 	id_paket_jadwal: this.paketjadwal.id_paket_jadwal
			// })
			// .then(res => {
			// 	// this.getAllTryoutJadwal();
			// 	// this.lstjadwal.splice(index, 1);
			// 	// this.getAll();
			// 	swal.fire("Jadwal berhasil dihapus!", {
			// 		icon: "success",
			// 	});
			// 	this.getJadwal(this.paket);
				
			// })
			// .catch(err => {
			// 	// handle error
			// 	console.log(err);
			// })
			
			
			swal.fire({
				title: "Hapus Jadwal Paket?",
				text: "Apakah anda yakin akan menghapus jadwal ini?",
				icon: "warning",
				showCloseButton: true,
				showCancelButton: true,
				buttons: true,
				dangerMode: true,
				})
				.then((willDelete) => {
					if (willDelete.value) {
						axios.post('api/paketjadwaldel', {
							id_paket: this.paket.id_paket,
							id_paket_jadwal: ref.id_paket_jadwal
						})
						.then(res => {
							this.lstjadwal.splice(index, 1);
							this.getAll();
							swal.fire("Jadwal berhasil dihapus!", {
								icon: "success",
							});
							
						})
						.catch(err => {
							// handle error
							console.log(err);
						})

						
					} else {
						swal("Jadwal gagal dihapus");
					}
				})

			
		},

		saveJadwal: function (paketjadwal) {
            axios.post('api/paketjadwal', {
                    id_paket: this.paket.id_paket,
					paketjadwal: this.paketjadwal,
                })
                .then(res => {
                    // handle success
					// this.clearTbl("tblJadwal");
					this.getEditPaket(this.paket.id_paket);
                    // this.initDt("tblJadwal");
					this.isFormJadwal = false;
					this.paketjadwal = [];
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		// deleteJadwal: function(index){
		// 	this.lstjadwal.splice(index, 1);
		// },
		
      
		getLdt: function(ref){
			this.ldt =[];
			this.paket = [];
			this.lstsoal = [];
			this.lstldtsiswa = [];
			this.clearTbl("tblLdt");
            this.initDt("tblLdt");
			this.getEditPaket(ref.id_paket);
            $("#ldtMdl").modal('show');
		},

		getLdtSiswa: function () {

            axios.get('api/ldtsiswabypaketjadwal/'+this.paket.id_paket+'/'+this.id_paket_jadwal)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLdt");
                    this.lstldtsiswa = res.data.data;
                    this.initDt("tblLdt");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		
        getPreview: function (ref) {
            this.ldt = ref;
			this.lstsoal = []; 
            axios.get('api/ldtpreviewsoal/'+ref.id_user+'/'+ref.id_paket_sales+'/'+ref.id_paket_jadwal) //+this.$route.params.id)
                .then(res => {
                    $("#previewMdl").modal('show');

                    this.lstsoal = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		getJadwal: function (ref) {   
			this.paketjadwal = this.refpaketjadwal;
			this.isFormJadwal = false;
			this.clearTbl("tblJadwal");
			this.getEditPaket(ref.id_paket);
			this.initDt("tblJadwal");
			this.getAllTryoutJadwal();
			this.getAllCoach();
            $("#jadwalMdl").modal('show');
        },
 
		//--------------------------
		
		// GET Tryout
		getAllTryoutJadwal: function () {
            axios.get('api/tryout')
                .then(res => {
                    this.lsttryoutjadwal = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		// GET Tryout
		getAllCoach: function () {
            axios.get('api/lstuserbyhakakses/2')
                .then(res => {
                    this.lstcoach = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		// ------------------Tugas
		
		getTugas: function(ref){
			this.paket = [];
			this.lsttugassiswa = [];
			this.clearTbl("tblTugas");
            this.initDt("tblTugas");
			this.getEditPaket(ref.id_paket);
            $("#tugasMdl").modal('show');
		},

		getTugasSiswa: function () {

            axios.get('api/tugassiswabypaketjadwal/'+this.paket.id_paket+'/'+this.id_paket_jadwal)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblTugas");
                    this.lsttugassiswa = res.data.data;
                    this.initDt("tblTugas");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		async getLinkTugas(ref) {
			try {
				await navigator.clipboard.writeText(ref.url_tugas)
				
				swal.fire("Berhasil dicopy!", {
					icon: "success",
				});
			} catch (err) {
				swal.fire("Gagal dicopy!", {
					icon: "warning",
				});
			}
		},
		
		// ------------------Kehadiran
		
		getKehadiran: function(ref){
			this.paket = [];
			this.lstkehadiransiswa = [];
			this.clearTbl("tblKehadiran");
            this.initDt("tblKehadiran");
			this.getEditPaket(ref.id_paket);
            $("#kehadiranMdl").modal('show');
		},

		getKehadiranSiswa: function () {

            axios.get('api/tugassiswabypaketjadwal/'+this.paket.id_paket+'/'+this.id_paket_jadwal)
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblKehadiran");
                    this.lstkehadiransiswa = res.data.data;
                    this.initDt("tblKehadiran");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Bimbel/index.vue